import { Path, PathValue, UseFormSetValue } from "react-hook-form";
import { useTimezoneSelect } from "~/components/datetime/useTimezoneSelect";
import ThemedAutocomplete from "./ThemedAutoComplete";

interface TimeZoneAutoCompleteProps<T extends { timezone?: string }> {
    setValue: UseFormSetValue<T>;
    initialValue?: string;
    disabled?: boolean;
}

const TimeZoneAutoComplete = <T extends { timezone?: string }>({
    setValue,
    initialValue,
    disabled,
}: TimeZoneAutoCompleteProps<T>) => {
    const { options } = useTimezoneSelect({});

    // Infer the type of a single option
    type TimezoneOption = (typeof options)[number];

    return (
        <ThemedAutocomplete<TimezoneOption>
            selected={options.find((option) => option.value === initialValue)}
            onSelected={(value) => {
                if (value) {
                    setValue(
                        "timezone" as Path<T>,
                        value.value as PathValue<T, Path<T>>,
                        {
                            shouldDirty: true,
                        },
                    );
                }
            }}
            data={options}
            idKey="value"
            valueKey={["label"]}
            className="w-full"
            disabled={disabled}
        />
    );
};

export default TimeZoneAutoComplete;
